export default __webpack_public_path__ + "static/media/banner-two.77522aa6.jpg";